export const JOIN_STEP = 'JOIN_STEP';
export const MEMBER_CHECK_ID = 'MEMBER_CHECK_ID';
export const MEMBER_CHECK_ERROR = 'MEMBER_CHECK_ERROR';
export const MEMBER_JOIN = 'MEMBER_JOIN';



// WEBPACK FOOTER //
// ./src/constants/join.js